import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';

export default function BarLabel() {
  return (
    <BarChart
      xAxis={[{ scaleType: 'band', data: ['گروه 1', ' گروه 2', 'گروه 3'], }]}
      series={[{ data: [4, 3, 5] }, { data: [1, 6, 3] }, { data: [2, 5, 6] }]}
      
      barLabel="value"
    />
  );
}